import { Flex } from 'antd';
import { Modal, Button } from '../Ant';
import { Paragraph, Text } from '../Ant/Typography';
import { RefreshLinear } from '../icons';
import { useTranslation } from 'react-i18next';

interface UpdateModalProps {
  open: boolean;
  onClose?: () => void;
  onUpdate: () => void;
  version?: string;
  releaseDate?: string;
}

const VersionUpdateModal = ({
  open,
  onClose,
  onUpdate,
  version,
  releaseDate,
}: UpdateModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={370}
      maskClosable={false}
      closeIcon={null}
      data-testId="version-update-modal"
    >
      <Flex vertical align="center">
        <RefreshLinear className="text-clr-icon-color fz-93 mb-20" />

        <Paragraph $color="title" $fontsize="16px" $lineheight="22px" $weight={600} $mb={20}>
          {t('common:update.updateCsi')}
        </Paragraph>

        <Flex vertical gap={5} align="center" className="mb-15">
          <Paragraph
            $color="subtitle"
            $fontsize="13px"
            $lineheight="20px"
            data-testId="latest-version"
          >
            {t('common:latestVersion')}:{' '}
            <Text $color="title" $weight={600}>
              {version}
            </Text>
          </Paragraph>

          <Paragraph
            $color="subtitle"
            $fontsize="13px"
            $lineheight="20px"
            data-testId="release-date"
          >
            {t('common:releaseDate')}:{' '}
            <Text $color="title" $weight={600}>
              {releaseDate}
            </Text>
          </Paragraph>

          <Paragraph
            $color="description"
            $fontsize="13px"
            $lineheight="20px"
            className="ta-center"
            data-testId="force-update-description"
          >
            {t('common:forceUpdateVersionAddinDescription')}
          </Paragraph>
        </Flex>

        <Flex gap={10} className="w-full">
          <Button type="primary" onClick={onUpdate} block size="large" data-testId="reload-button">
            {t('common:profile.update')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default VersionUpdateModal;
